import $ from 'jquery';
import {Easings, smoothy} from "smoothy";

$('.footer__newsletter form').on('submit', ev => {
    ev.preventDefault();
    let $form = $(ev.currentTarget);
    let $input = $form.find('.footer-newsletter-email');
    let email = $input.val().trim();
    if (!email) {
        return;
    }
    let url = $form.attr('data-url');
    url = `${url}#newsletter:${email}`;
    location.href = url;
});


(() => {
    const $form = $('#cleverreach-form');
    if ($form.length === 0) {
        return;
    }

    if (!location.hash.startsWith('#newsletter:')) {
        return;
    }
    $form.find('input[name="email"]').val(location.hash.substring(12).trim());
    smoothy(() => $form.offset().top, 1000, Easings.easeOutQuint).then(() => {
        history.pushState({}, '', location.pathname);
    });
})();

